import { gameBoardToggleRace } from "../actions/ui";
import { connect } from "react-redux";
import { getExpandedRace } from "../selectors";
import PlayFieldRace from "../components/play-field-race";

function select(state, props) {
  return {
    expandedRace: getExpandedRace(state, props)
  };
}

export default connect(select, { gameBoardToggleRace })(PlayFieldRace);
